import type { OutboundData } from "@/platform/bridge/envelope"
import { type NativeBridge, BridgeRequestError, hostSupports, legacyHostSupports, postRawToNativeHost } from "@/platform/bridge/use-native-bridge"

const SHARE_REQUEST_TIMEOUT_MS = 600_000

export type NativeShareResult = "shared" | "dismissed" | "unavailable"

type NativeShareType = "share.open" | "share.story" | "share.channel"

export const canShareNatively = (bridge: NativeBridge, type: NativeShareType): boolean => bridge.available && hostSupports(type)

export const shareNatively = async <T extends NativeShareType>(bridge: NativeBridge, type: T, data: OutboundData<T>): Promise<NativeShareResult> => {
  try {
    const result = await bridge.request(type, data, SHARE_REQUEST_TIMEOUT_MS)
    return result.outcome === "dismissed" ? "dismissed" : "shared"
  } catch (error) {
    return error instanceof BridgeRequestError && error.code === "cancelled" ? "dismissed" : "unavailable"
  }
}

const LEGACY_SHARE_ACTION = "share.open"

export const canShareViaLegacyHost = (): boolean => legacyHostSupports(LEGACY_SHARE_ACTION)

export const shareViaLegacyHost = (message: string): boolean => postRawToNativeHost({ action: LEGACY_SHARE_ACTION, message })
